import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

import { trackPageView } from '@/services/analytics';
import { resolveRoutePattern } from '@/services/analytics/patterns';

// Headless: emits a page_view (route pattern only, never the raw URL) on each navigation.
export default function AnalyticsRouteTracker(): null {
  const location = useLocation();
  const last = useRef<string>('');

  useEffect(() => {
    const pattern = resolveRoutePattern(location.pathname);
    if (pattern !== last.current) {
      last.current = pattern;
      trackPageView(pattern);
    }
  }, [location.pathname]);

  return null;
}
